import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuickTransferService } from 'src/app/Services/quick-transfer.service';
import { UserService } from 'src/app/Services/user.service';
import { WalletService } from 'src/app/Services/wallet.service';
import { environment } from 'src/environments/environment';
import { ExchangeService } from 'src/app/Services/exchange.service';

declare var $: any;
@Component({
    selector: 'app-quick-trasnfer-modal',
    templateUrl: './quick-transfer-modal.component.html',
    styleUrls: ['./quick-transfer-modal.component.scss']

})
export class QuickTransferModalComponent implements OnInit {

    // GENERAL DATA
    userData: any = {};
    profileData: any = {};
    message: any = '';
    errors: any = {};
    title: any = '';
    process: any = false;
    verificationCount: number = undefined;
    verificationStatusEnum: any = undefined;
    unsubscribe$: Subject<void> = new Subject<void>();

    // CURRENCIES DATA
    allCurrencies: any = [];
    localCurrencies: any = [];
    currencies: any = [];
    currentPreferredCurrency: any;
    currentSendCurrency: any;
    estimateValue = '0.0';

    // USERS LIST
    userList: any = undefined;
    autoSearchuserList: any = [];

    // SEND COIN
    sendCoinData: any = {};
    sendCoinDatacoinType: any = '';
    coinTypes: any = [];
    selectedCoin: any = {};
    selectedCurrency: any = {};
    freezeSendCoin = false;
    sendCoinAsset = false;

    // ADD USER
    prefferedFullName: any = '';
    isAdding: any = false;
    addUserClicked = false;
    addAddress: any = { verificationCode: 'XXXXXX' };
    referenceNumber: any = '';
    userToAddFirstName = '';

    // DELETE USER
    deleteId: any = {};

    // FEE
    feeLimitData: any = {};
    feeLimitErrorAmount: any;
    feeLimitErrorMaxAmount: any;

    @Input() themeColor: boolean = true;
    public imgUrl: any = environment.imgUrl;
    constructor(
        private userService: UserService,
        private walletService: WalletService,
        public exchangeService: ExchangeService,
        private quickTransferService: QuickTransferService,
        private route: Router,
        private toast: ToastrService,
        private translate: TranslateService,
        private cookieService: CookieService
    ) {
        this.userData = this.userService.getLoggedData();

        if (!this.userData.verificationStatus) {
            this.setVerificationStatusString();
        }
        if (this.userData && this.userData.preferredCurrency && this.userData.preferredCurrency.shortName)
            this.coinTypes = [{ key: '', value: 'Assets' }, { key: this.userData.preferredCurrency.shortName, value: 'Currency' }];
        this.userService.changeLanguageEvent2.pipe(takeUntil(this.unsubscribe$)).subscribe(lang => {
            this.userData = this.userService.getLoggedData();
            this.userData.preferredLanguage = lang;
            this.userService.setUserData(this.userData);
            this.userData = this.userService.getLoggedData();
            this.marginImage();
        });

        // this.getUserBook();
        // this.getFeeLimit();
    }


    ngOnInit() {
        this.dropDownsControl();

        this.marginImage();
        $(window).resize(() => {
            this.marginImage();
        });
        if (window.innerWidth <= 600) {
            if (document.getElementById('obsiImg') !== null)
                document.getElementById('obsiImg').style.margin = '10px 10px 5px 5px';
        }
        // console.log(this.userData)
        if (!this.userData.verificationStatus) {
            this.verificationCount = this.userData.verificationCount;
            // this.userService.getProfileData(this.userData.token).pipe(takeUntil(this.unsubscribe$)).subscribe(async (m: any) => {
            //     if (m.status === 200) {
            //         this.verificationCount = m.data.verificationCount;
            //     }
            // });
        }

        this.userService.changeData.pipe(takeUntil(this.unsubscribe$)).subscribe(isOpen => {
            this.userData = this.userService.getLoggedData();
            this.setVerificationStatusString();
        });
        if (!this.userData.verficationStatus) {
            this.userService
              .getProfileData(this.userData.token)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe(async (m: any) => {
                if (m.status === 200) {
                  this.verificationCount = m.data.verificationCount;
                }
              });
          }
        $(document).click((e) => {
            if (!$(e.target).parent().parent().hasClass('boxs')) {
                setTimeout(() => {
                    $('.cointype').hide();
                }, 100);
            }
        });
        $('.filterme').keypress((eve) => {
            if ((eve.which !== 46 ||
                $(this).val().indexOf('.') !== -1) &&
                (eve.which < 48 || eve.which > 57) ||
                (eve.which === 46 &&
                    $(this).caret().start === 0)) {
                eve.preventDefault();
            }

            // this part is when left part of number is deleted and leaves a . in the leftmost position. For example, 33.25, then 33 is deleted
            $('.filterme').keyup(() => {
                if ($(this).val().indexOf('.') === 0) {
                    $(this).val($(this).val().substring(1));
                }
            });
        });

    }

    getIp() {
        this.sendCoinData.location = 'unknown';
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getNewCurrencies() {

        this.exchangeService.getExchangeBalance().pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
            if (m.status === 200) {
                m.data.map((k) => {
                    k.shortName = k.asset
                    if (!k.availableBalance)
                        k.availableBalance = 0
                })
                this.allCurrencies = m.data;
                let set = []
                if (this.userData && this.userData.preferredCurrency && this.userData.preferredCurrency.shortName) {
                    set = this.allCurrencies.filter((a) => a.shortName === this.userData.preferredCurrency.shortName);
                }
                this.prefferedFullName = set.length ? set[0] : '';
                this.currentPreferredCurrency = this.allCurrencies[0];
            }
        });
    }

    getUserBook() {
        this.quickTransferService.getUserBook(this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
            if (m.status === 200) {
                (this.userService.notificationList).map((n) => {
                    if (['userAdded'].indexOf(n.notificationType) !== -1) {
                        this.userService.clearNotification('OBSIPAY_ADDED').pipe(takeUntil(this.unsubscribe$)).toPromise().then((m2: any) => {
                            this.userService.readNotification();
                        });
                    }
                });
                this.userList = m.data;
            }

            if (!this.userList) {
                this.userList = [];
            }
        });
    }

    getUsers(event) {
        this.currencies = [];
        if (!this.autoSearchuserList.length) {
            this.autoSearchuserList = this.userList;
        } else {
            this.autoSearchuserList = [];
        }
    }

    searchCurrency(event) {
        this.autoSearchuserList = [];
        if (!this.currencies.length) {
            this.currencies = this.allCurrencies;
        } else {
            this.currencies = [];
            if (event.target.value === '') {
                this.selectedCoin = {};
                this.changeSendCoinType(this.currentSendCurrency, this.currentPreferredCurrency);
            }
        }
    }

    searchLocalCurrency(event) {
        this.currencies = [];
        if (!this.localCurrencies.length) {
            const currencies = (JSON.parse(localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES')) || []).filter((c) => {
                return c.fullName.toLowerCase().indexOf((event.target.value || '').toLowerCase()) !== -1;
            });
            this.localCurrencies = event.target.value ? currencies : (JSON.parse(localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES')) || []);

            let Currencies = [];
            this.walletService.getCurrencies().pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
                if (m.status === 200) {
                    Currencies = m.data;
                    const currencies2 = (Currencies || []).filter((c) => {
                        return c.fullName.toLowerCase().indexOf((event.target.value || '').toLowerCase()) !== -1;
                    });
                    this.localCurrencies = event.target.value ? currencies2 : (JSON.parse(this.cookieService.get('LocalCurrencies')) || m.data);

                }
            });
        } else {
            this.localCurrencies = [];
        }
    }

    selectCurrencyForSendCoin(currency) {
        this.selectedCurrency = currency;
        this.currentSendCurrency = currency;
        this.localCurrencies = [];
        this.estimateValue = '0';
        $('#amount2').val('');
        this.calculateEstimateValue();
    }

    selectUserForSendCoin(user) {
        this.errors.sendUserId = '';
        this.sendCoinData.payeeId = user.payeeId;
        // this.sendCoinData.userId = this.userData.userId;
        this.autoSearchuserList = [];
        $('#coin2').val(user.username);
    }

    selectCoinForSendCoin(coin) {
        this.errors.sendCoinId = '';
        this.selectedCoin = coin;
        this.sendCoinData.coinId = coin.coinId;
        this.sendCoinData.shortName = coin.shortName;
        this.sendCoinData.price = coin.price;
        if (this.userData && this.userData.preferredCurrency && this.userData.preferredCurrency.shortName)
            this.coinTypes = [{ key: coin.shortName, value: 'Assets' }, { key: this.userData.preferredCurrency.shortName, value: 'Currency' }];

        $('#sendcoin2').val(coin.fullName);
        this.currencies = [];

        if (this.sendCoinAsset) {
            this.currentPreferredCurrency = this.allCurrencies.filter((c) => c.shortName === coin.shortName)[0];
        } else {
            this.currentSendCurrency = this.allCurrencies.filter((c) => c.shortName === coin.shortName)[0];
        }
        this.calculateEstimateValue();
        if (window.innerWidth > 1200) {
            if (document.getElementById('boxAmount2') !== null)
                document.getElementById('boxAmount2').style.marginRight = '10%';
        }
        this.estimateValue = '0';
        $('#amount2').val('');
    }
    openDelete(user) {
        this.deleteId = user;
        $('#sure_wh').modal('show');
    }

    openSendCoinToUser(user) {
        this.openObsidiamModal();
        this.selectUserForSendCoin(user);
    }
    validateSendCoin() {
        let err = false;
        this.errors = {};
        if (!this.sendCoinData.amount || isNaN(this.sendCoinData.amount)) {
            err = true;
            this.errors.sendAmount = 'quick_transfer.error.amount';
            if (this.selectedCoin.availableBalance < this.sendCoinData.amount) {
                this.errors.sendAmount = 'quick_transfer.error.amountInsufficient';
            }
        }
        if (!this.sendCoinData.shortName) {
            err = true;
            this.errors.sendCoinId = 'quick_transfer.error.coin';
        }
        if (!this.sendCoinData.payeeId) {
            err = true;
            this.errors.sendUserId = 'quick_transfer.error.payee';
        }
        return !err;
    }

    marginImage() {
        if (this.userData.preferredLanguage === 'en') {
            if (window.innerWidth > 600) {
                $('#addUserImg').css('margin', '-10px 10px 0 10px');
            } else {
                $('#addUserImg').css('margin', '10px');
            }
        } else {
            $('#addUserImg').css('margin', '0px 10px 0 10px');
        }
    }

    addAddressPopup() {
        if (this.userData.verificationStatus) {
            $('#popupAddUser').modal('show');
            $('#popupAddUser form').trigger('reset');
            this.addAddress.verificationCode = 'XXXXXX';
            this.errors.username = this.errors.label = this.errors.authyCode = '';
        } else {
            $('#quick').modal('show');
        }
    }

    closeAddressPopup() {
        $('#popupAddUser').modal('hide');
    }

    openObsidiamModal() {
        this.getUserBook();
        this.getFeeLimit()

    }

    checksOnModalOpen() {
        if (this.feeLimitData.dailyLimitLeft < this.feeLimitData.minimumTransactionAmount) {
            this.translate.get('quick_transfer.error.minimumAmount_fee').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {

                this.toast.info(er, '', {
                    timeOut: 15000
                });
            });
        } else {
            this.getNewCurrencies();
            this.errors = {};

            this.sendCoinAsset = true;
            this.selectedCoin = {};
            if (document.getElementById('boxAmount2') !== null)
                document.getElementById('boxAmount2').style.marginRight = '0px';
            const localCurrencies = localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES');
            if (localCurrencies) {
                const auxCurrencies = JSON.parse(localCurrencies);
                const current = auxCurrencies.filter((c) => c.shortName === this.userData.preferredCurrency.shortName);
                if (current.length === 1) {
                    this.selectedCurrency = current[0];
                    this.selectCurrencyForSendCoin(current[0]);
                    this.currentSendCurrency = current[0];
                }
            } else {
                this.walletService.getCurrencies().pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
                    if (m.status === 200) {
                        const auxCurrencies = m.data;
                        const current = auxCurrencies.filter((c) => c.shortName === this.userData.preferredCurrency.shortName);
                        if (current.length === 1) {
                            this.selectedCurrency = current[0];
                            this.selectCurrencyForSendCoin(current[0]);
                            this.currentSendCurrency = current[0];
                        }
                    }
                });
            }
            // Disable scroll number
            $(':input[type=number]').on('mousewheel', () => { $(this).blur(); });

            if (this.userData.verificationStatus && this.userList && this.userList.length) {
                this.autoSearchuserList = [];
                this.currencies = [];
                this.sendCoinData = {};

                $('#popupObsidiam form').trigger('reset');
                $('#popupObsidiam').modal('show');
            } else {
                if (!this.userData.verificationStatus) {
                    $('#quick').modal('show');
                } else {
                    $('#popupObsidiam').modal('show');
                }
            }

        }
    }

    getFeeLimit() {
        this.quickTransferService.getFeeLimit(this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
            if (m.status === 200) {
                this.feeLimitData = m.data;
                this.checksOnModalOpen()
            }
        });
    }


    closeAuthy() {
        this.title = '';
        $('.modal form').trigger('reset');
        $('.modal').modal('hide');
    }

    async sendCoin() {
        this.feeLimitErrorMaxAmount = ''
        const valid = this.validateSendCoin();
        if (valid && !this.freezeSendCoin) {
            let amountToSend = this.sendCoinData.amount;
            let selectedCoinT = this.allCurrencies.filter((m) => {
                return m.shortName === this.sendCoinData.shortName;
            });
            selectedCoinT = selectedCoinT.length ? selectedCoinT[0] : {};
            let amountToSendInUSD = 0;
            if (this.sendCoinAsset) {
                amountToSend = (this.sendCoinData.amount / (selectedCoinT.price * (this.selectedCurrency.value || 1))).toFixed(8);
                amountToSendInUSD = this.sendCoinData.amount / this.selectedCurrency.value;
            } else {
                amountToSendInUSD = this.sendCoinData.amount * selectedCoinT.price;
            }
            if (amountToSendInUSD < this.feeLimitData.minimumTransactionAmount) {
                this.translate.get('quick_transfer.error.minimumAmount').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                    this.errors.sendAmountMin = er;
                    this.feeLimitErrorAmount = this.feeLimitData.minimumTransactionAmount;
                });
            } else if (this.feeLimitData.dailyLimitLeft < this.feeLimitData.minimumTransactionAmount) {
                this.translate.get('quick_transfer.error.minimumAmount_fee').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {

                    this.toast.info(er, '', {
                        timeOut: 15000
                    });
                });
            } else if (amountToSendInUSD > this.feeLimitData.dailyLimitLeft && this.feeLimitData.dailyLimitLeft !== 0) {
                this.translate.get('quick_transfer.error.maximumAmount').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                    this.errors.sendAmountMin = er;
                    this.feeLimitErrorAmount = this.feeLimitData.dailyLimitLeft;
                });
            } else if (this.selectedCoin.availableBalance < amountToSend) {
                this.errors.sendAmount = 'quick_transfer.error.amountInsufficient';
            } else {
                this.sendCoinData.location = 'unknown';
                const data: any = {
                    amount: this.sendCoinData.amount,
                    coinShortName: this.sendCoinData.shortName,
                    ipAddress: this.sendCoinData.ipAddress,
                    location: this.sendCoinData.location,
                    payeeId: this.sendCoinData.payeeId,
                    userId: this.sendCoinData.userId,
                    price: this.sendCoinData.price,
                    preferredCurrency: this.selectedCurrency.shortName || this.userData.preferredCurrency.shortName
                };
                if (this.sendCoinAsset || this.sendCoinDatacoinType === this.userData.preferredCurrency.shortName) {
                    let selectedCoin = this.allCurrencies.filter((m) => {
                        return m.shortName === this.sendCoinData.shortName;
                    });
                    selectedCoin = selectedCoin.length ? selectedCoin[0] : {};
                    data.amount = this.sendCoinData.amount / (selectedCoin.price * (this.selectedCurrency.value || 1));
                    if (data.coinShortName == 'COP') {
                        data.price = (selectedCoin.price * (this.selectedCurrency.value || 1));
                    } else {
                        data.price = (selectedCoin.price * (this.selectedCurrency.value || 1)).toFixed(2);
                    }
                    // data.price = (selectedCoin.price * (this.selectedCurrency.value || 1)).toFixed(2);
                }

                this.freezeSendCoin = true;
                this.quickTransferService.transferFund(data, this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
                    $('.modal').modal('hide');
                    $('.modal form').trigger('reset');
                    if (m.status === 200) {

                        this.getFeeLimit()
                        this.translate.get('success').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                            const msg = m.message;
                            const err = er;
                            this.message = msg;
                            this.toast.success(msg, err, {
                                timeOut: 15000
                            });
                        });
                    } else {
                        this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                            const msg = m.message;
                            const err = er;
                            this.message = msg;
                            this.toast.error(msg, err, {
                                timeOut: 15000
                            });
                        });
                    }

                    setTimeout(() => {
                        this.freezeSendCoin = false;
                    }, 500);
                });
            }
        }
    }

    deleteUser() {
        if (this.deleteId) {
            const data = {
                id: this.deleteId.id
            };
            this.quickTransferService.deleteUser(data, this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
                $('.modal form').trigger('reset');
                $('.modal').modal('hide');
                if (m.status === 200) {
                    this.getUserBook();
                    this.message = m.message || 'User deleted successfully';
                    this.translate.get('success').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                        const msg = m.message;
                        const err = er;
                        this.message = msg;
                        this.toast.success(msg, err, {
                            timeOut: 15000
                        });
                    });
                } else {
                    this.title = 'Delete User';

                    this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                        const msg = m.message;
                        const err = er;
                        this.message = msg;
                        this.toast.error(msg, err, {
                            timeOut: 15000
                        });
                    });
                }
            });
        }
    }

    addAddressToUserBook(sure = false) {
        if (!this.addUserClicked) {
            this.addUserClicked = true;
            if (!this.errors.username) {
                this.checkUsername();
            }
            setTimeout(() => {
                if (this.addAddress.username && this.addAddress.label && !this.errors.username
                    && this.addAddress.username !== this.userData.username) {
                    if (sure) {
                        if (!this.isAdding) {
                            this.isAdding = true;
                            $('body').css({ 'pointer-events': 'none' });
                            this.addAddress.userId = this.userData.userId;
                            this.addAddress.senderUsername = this.userData.username;
                            this.addAddress.username = this.addAddress.username.trim();

                            this.quickTransferService.addUser(this.addAddress, this.userData.token)
                                .pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
                                    $('.modal form').trigger('reset');
                                    $('.modal').modal('hide');
                                    this.process = false;
                                    this.isAdding = false;

                                    setTimeout(() => {
                                        this.addUserClicked = false;
                                    }, 500);
                                    if (m.status === 200) {
                                        // console.log("Entro aqui addAddressToUserBook");
                                        this.referenceNumber = m.data.referenceNumber;
                                        this.message = m.message;
                                        $('#popupAuthy').modal('show');
                                        this.addUserStatus();
                                        this.getUserBook();
                                    } else {
                                        this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                                            const msg = m.message;
                                            const err = er;
                                            this.message = msg;
                                            this.toast.error(msg, err, {
                                                timeOut: 15000
                                            });
                                        });
                                    }
                                });
                        } else {
                            this.addUserClicked = false;
                        }
                    } else {
                        $('.modal').modal('hide');
                        this.title = '';
                        this.message = 'quick_transfer.are_sure_add_user';
                        $('#sure_wh_send_popup').modal('show');
                        this.addUserClicked = false;
                    }
                    this.errors = {};
                } else {
                    this.addUserClicked = false;
                    if (!this.addAddress.username) {
                        this.errors.username = 'quick_transfer.error.username';
                    } else {
                        if (this.addAddress.username === this.userData.username) {
                            this.errors.username = 'quick_transfer.error.cant';
                        }
                    }
                    if (!this.addAddress.label) {
                        this.errors.label = 'quick_transfer.error.label';
                    }

                }
            }, 500);
        }
        this.getUserBook();
    }

    addUserStatus() {
        if (this.referenceNumber) {
            this.quickTransferService.checkAddUserStatus(this.referenceNumber, this.userData.token)
                .pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
                    $('.modal form').trigger('reset');
                    if (m.status === 200) {
                        this.getUserBook();
                        $('.modal').modal('hide');
                        this.translate.get('success').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                            const msg = m.message;
                            const err = er;
                            this.message = msg;
                            this.toast.clear();
                            this.toast.success(msg, err, {
                                timeOut: 15000
                            });
                        });
                    } else {
                        this.message = m.message;
                        if (m.status === 423) {
                            setTimeout(() => {
                                this.addUserStatus();
                            }, 10000);
                        } else {
                            $('.modal').modal('hide');
                            this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                                const msg = m.message;
                                const err = er;
                                this.message = msg;
                                this.toast.clear();
                                this.toast.error(msg, err, {
                                    timeOut: 15000
                                });
                            });
                        }
                    }
                });
        }
    }

    checkUsername() {
        if (this.addAddress.username) {
            this.addAddress.username = this.addAddress.username.trim();
        }
        if (this.addAddress.username) {
            if (this.addAddress.username !== this.userData.username) {
                if (this.addAddress.username.length < 3) {
                    this.errors.username = 'quick_transfer.error.user_name_length';
                } else {
                    this.userService.getFirstName(this.addAddress.username).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
                        if (m.status === 200) {
                            this.errors.username = '';
                            if (!this.addAddress.verificationCode.includes('X')) {
                                this.addAddressToUserBook();
                            }
                            this.userToAddFirstName = m.data.firstName;
                        } else {
                            this.errors.username = m.message || 'Username not exist.';
                        }
                    });
                }
            } else {
                this.errors.username = 'quick_transfer.error.cant';
            }
        }
    }

    setAuthy(val, i) {
        if (i === 0) {
            this.addAddress.verificationCode = 'XXXXXX';
        }
        const str = this.addAddress.verificationCode.split('');
        str[i] = val || 'X';
        this.addAddress.verificationCode = str.join('');
        if (!this.addAddress.verificationCode.includes('X')) {
            this.addAddressToUserBook();
        }
    }

    controlInputAmount() {
        const parts = $('#amount2').val().toString().split('.');
        parts[0] = parts[0].split(',').join('');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        $('#amount2').val(parts.join('.'));
        this.sendCoinData.amount = $('#amount2').val().split(',').join('');
    }

    // changeSendCoinType(currentSendCurrency, currentPreferredCurrency) {
    //     this.sendCoinAsset = !this.sendCoinAsset;
    //     this.currentSendCurrency = currentPreferredCurrency;
    //     this.currentPreferredCurrency = currentSendCurrency;
    //     this.calculateEstimateValue();
    // }

    changeSendCoinType(currentSendCurrency, currentPreferredCurrency) {

        this.sendCoinAsset = !this.sendCoinAsset;
        let val = $('#amount2').val()
        if (val) {
            val = parseFloat(val)
            //   console.log(currentSendCurrency, currentPreferredCurrency, this.sendCoinAsset, val)
            this.currentSendCurrency = currentPreferredCurrency;
            this.currentPreferredCurrency = currentSendCurrency;
            let selectedCoin = this.allCurrencies.filter((m) => {
                return m.shortName === this.sendCoinData.shortName;
            });
            selectedCoin = selectedCoin.length ? selectedCoin[0] : {};
            if (this.sendCoinAsset) {
                // currency is selected
                val = (val * currentSendCurrency.priceUsd * currentPreferredCurrency.value).toFixed(2);
            } else {
                val = (val / (currentPreferredCurrency.priceUsd * currentSendCurrency.value)).toFixed(8);
                // coin is selected

            }
            $('#amount2').val(val + '')
            this.controlInputAmount()

            this.calculateEstimateValue();
        }
    }

    restrictNumberLength(event: any, value: string) {
        let fontSize = $('#amount2').css('fontSize').replace('px', '');
        if (event.key === 'Backspace') {
            if (fontSize < 40) {
                if (window.innerWidth < 600) {
                    if (value.length >= 8) {
                        fontSize = Number(fontSize) + 2;
                    } else {
                        fontSize = Number(fontSize) + 7;
                    }
                } else {
                    fontSize = Number(fontSize) + 2.1;
                }
                $('#amount2').css('fontSize', fontSize);
            }
            return true;
        }
        const num = (!this.sendCoinAsset ? '8,7' : '8,1').toString().split(',');
        const regex = new RegExp('^[-+]?\\d{0,' + num[0] + '}(\\.\\d{0,' + num[1] + '})?$');
        if (!regex.test(value.split(',').join(''))) {

            return false;
        }
        if (event.key == '.' && value.indexOf('.') != -1) {
            return false;
        }
        if (event.key == '.' && value.indexOf('.') == -1) {
            value = value.toString() + event.key;
        }

        if (value.length && !Number(value.split(',').join('')) && value.indexOf('.') == -1) {
            return false;
        }
        if ((value.includes('.') && value.split(',').join('').length >= 16) ||
            (!value.includes('.') && value.split(',').join('').length >= 15)) {
            return false;
        }

        if ((value.split(',').join('') + event.key.toString()).match(/^([0-9]|\.)+$/)) {
            if (window.innerWidth < 600) {
                if (value.length >= 8 && (Number(fontSize) - 5) > 21) {
                    fontSize = Number(fontSize) - 5;
                } else if (fontSize >= 19) {
                    fontSize = Number(fontSize) - 5;
                }
            } else {
                if (value.length >= 8 && (Number(fontSize) - 2.1) > 21) {
                    fontSize = Number(fontSize) - 2.1;
                }
            }
            $('#amount2').css('fontSize', fontSize);
            return true;
        }
        if (value.split(',').join('').length < 9 && value.indexOf('.') != -1) {
            return true;
        }
        return false;

    }

    calculateEstimateValue() {
        this.errors.sendAmount = '';
        this.errors.sendAmountMin = '';
        let selectedCoin = this.allCurrencies.filter((m) => {
            return m.shortName === this.sendCoinData.shortName;
        });
        selectedCoin = selectedCoin.length ? selectedCoin[0] : {};
        this.controlInputAmount();
        if (this.sendCoinAsset) {
            this.estimateValue = (this.sendCoinData.amount / (selectedCoin.price * (this.selectedCurrency.value || 1))).toFixed(8);
        } else {
            this.estimateValue = (this.sendCoinData.amount * selectedCoin.price * this.selectedCurrency.value).toFixed(2);
        }
        // Commas in number
        const parts = this.estimateValue.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        this.estimateValue = parts.join('.');
    }

    routerToVerification() {
        $('#quick').modal('hide');
        this.setVerificationStatusString();
        setTimeout(() => {
            if (this.verificationCount >= 3 || this.userData.verificationStatusString === 'SUBMITTED' || this.userData.verificationStatus) {
                this.route.navigate(['/profile/verification']);
            } else {
              if (this.userData.userType === 'BUSINESS') {
                this.route.navigate(['/verification-guide/business']);
                return false;
              }
                this.route.navigate(['/verification-guide']);
            }
        }, 200);
    }

    setVerificationStatusString() {
        if (this.userData.verificationStatus) {
            this.verificationStatusEnum = 'verified';
        } else {
            this.userService.getProfileData(this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m2: any) => {
                if (m2 && m2.status === 200) {
                    this.profileData = m2.data;
                    this.userData.verificationStatus = m2.data.verificationStatus;
                    this.userData.verificationStatusString = m2.data.verificationStatusString;
                    switch (this.userData.verificationStatusString) {
                        case 'PENDING':
                            this.translate.get('verification_status.unverified').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                                this.verificationStatusEnum = er;
                            });
                            break;
                        case 'SUBMITTED':
                            this.translate.get('verification_status.pending').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                                this.verificationStatusEnum = er;
                            });
                            break;
                        case 'SUCCESS':
                            this.translate.get('verification_status.verified').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                                this.verificationStatusEnum = er;
                            });
                            break;
                        case 'FAILED':
                            this.translate.get('verification_status.failed').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
                                this.verificationStatusEnum = er;
                            });
                            break;
                        case 'ONBOARDING_PENDING':
                            this.translate
                                .get('verification_status.pending')
                                .pipe(takeUntil(this.unsubscribe$))
                                .subscribe((er: any) => {
                                this.verificationStatusEnum = er;
                                });
                            break;
                        case 'ONBOARDING_COMPLETED':
                        this.translate
                            .get('verification_status.inprocess')
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe((er: any) => {
                            this.verificationStatusEnum = er;
                            });
                            break;    
                    }
                }
            });
        }
    }

    dropDownsControl() {
        $(document).on('click', (e: { target: { id: string; }; }) => {
            if (e && e.target && e.target.id) {
                if (e.target.id !== 'coin2' && e.target.id !== 'coin2Img'
                    && this.autoSearchuserList && this.autoSearchuserList.length) {
                    this.autoSearchuserList = [];
                }
                if (e.target.id !== 'sendcoin2' && e.target.id !== 'sendcoin2Img'
                    && this.currencies && this.currencies.length) {
                    this.currencies = [];
                }
                if (e.target.id !== 'localCoin' && e.target.id !== 'downImg'
                    && this.localCurrencies && this.localCurrencies.length) {
                    this.localCurrencies = [];
                }
            }
        });
    }

    showMessage() {
        $('#popupObsidiam').modal('hide');
        this.route.navigate(['/quick-transfer']);
        this.quickTransferService.giveValueModal(true);
    }

    onPaste(event) {
        let clipboardData = event.clipboardData;
        let pastedText = clipboardData.getData('text');
        const regExp = new RegExp(/^([0-9]|\.)+$/);
        if (!regExp.test(pastedText)) {
            return false;
        } else {
            const num = (!this.sendCoinAsset ? '8,7' : '8,2').toString().split(',');
            const regex = new RegExp('^\\d{0,' + num[0] + '}(\\.\\d{0,' + num[1] + '})?$');
            if (!regex.test(pastedText.split(',').join(''))) {
                let val = pastedText.split(',').join('');
                let val2 = val.split('.');
                let result = 0;
                if (val2[1].length > Number(num[1])) {
                    result = val2[1].length - Number(num[1]);
                }
                $('#amount').val(val.substring(0, val.length - result));
            }
        }
    }

}
